export const AssociatedType = {
  CONTRIBUTOR: 1,
  PARTICIPANT: 2,
};
